var __WEBPACK_NAMESPACE_OBJECT__ = require("animate.css/animate.css");